import { styled } from 'goober';
export var PopoverContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '225px',
        height: 'auto',
        background: '#fff',
        border: "1px solid ".concat(theme.colors.neutral.w200),
        boxShadow: '0px 4px 16px rgba(107, 131, 160, 0.15)',
        borderRadius: '6px',
        display: 'flex',
        flexDirection: 'column',
        paddingRight: '5px',
    });
});
export var PopoverTitle = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.ui.dark,
        fontSize: theme.font.size,
        flexGrow: 0,
        fontWeight: 'bold',
        padding: '10px 7px 10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '.close-btn': {
            cursor: 'pointer',
        },
    });
});
export var PopoverContent = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        flexGrow: 1,
        overflow: 'auto',
        paddingBottom: '20px',
    });
});
export var ListFolderItem = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.ui.dark,
        fontSize: theme.font.size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '0px 0px 0px 20px',
        borderRadius: '4px',
        '&:hover': {
            background: theme.colors.neutral.w100,
        },
        'div.collapse-btn': {
            cursor: 'pointer',
            paddingTop: '3px',
        },
        'div.icon-btn': {
            visibility: 'hidden',
            cursor: 'pointer',
        },
        '&:hover div.icon-btn': {
            visibility: 'visible',
        },
    });
});
export var ListDocumentItem = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.colors.ui.dark,
        fontSize: theme.font.size,
        padding: '0px 0px 0px 20px',
        minHeight: '32px',
        display: 'flex',
        alignItems: 'center',
        marginLeft: '42px',
        cursor: 'pointer',
        borderRadius: '4px',
        '&:hover': {
            background: theme.colors.neutral.w100,
        },
    });
});
